import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit } from '@angular/core';
import { Cms } from '@impact/data';
import { IMPACT_OVERLAY_DATA, ImpactOverlayRef } from '@impactdk/ngx-overlay';
import { MediaSliderItem } from '../../media-slider/media-slider.component';

export interface ExteriorInteriorGallerySpotSlider {
    isExterior: boolean;
    exteriorGallery: Cms.Media[];
    interiorGallery: Cms.Media[];
    startIndex: number;
}

@Component({
    selector: 'app-exterior-interior-gallery-spot-slider',
    template: `
        <section class="exterior-interior-gallery-spot-slider" [ngSwitch]="isExterior" *ngIf="activeGallery">
            <app-media-slider *ngSwitchCase="true"
                class="exterior-interior-gallery-spot-slider__slider"
                [showNavigation]="true"
                [sliderItems]="activeGallery"
                [showThumbs]="false"
                [showPhotoName]="true"
                (closed)="onSliderClose()"
                [startIndex]="data.startIndex"
            ></app-media-slider>
            <app-media-slider *ngSwitchCase="false"
                class="exterior-interior-gallery-spot-slider__slider"
                [showNavigation]="true"
                [sliderItems]="activeGallery"
                [showThumbs]="false"
                [showPhotoName]="true"
                (closed)="onSliderClose()"
                [startIndex]="data.startIndex"
            ></app-media-slider>
            <app-exterior-interior-gallery-spot-buttons
                [isExterior]="isExterior"
                (exteriorClick)="selectExteriorGallery(true)"
                (interiorClick)="selectInteriorGallery(true)"
            >
            </app-exterior-interior-gallery-spot-buttons>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExteriorInteriorGallerySpotSliderComponent implements OnInit {

    isExterior: boolean;
    exteriorGallery: MediaSliderItem[] = [];
    interiorGallery: MediaSliderItem[] = [];
    activeGallery: MediaSliderItem[] = [];


    @HostListener('document:keydown.esc', ['$event'])
    onEscapeClose(): void {
        this.onSliderClose();
    }

    constructor(
        @Inject(IMPACT_OVERLAY_DATA) public data: ExteriorInteriorGallerySpotSlider,
        private overlayRef: ImpactOverlayRef,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.isExterior = this.data.isExterior;
        this.exteriorGallery = this.data.exteriorGallery.map((i) => ({ media: i }));
        this.interiorGallery = this.data.interiorGallery.map((i) => ({ media: i }));

        if (this.isExterior) {
            this.selectExteriorGallery(false);
        } else {
            this.selectInteriorGallery(false);
        }
    }

    selectExteriorGallery(resetIndex: boolean) {
        if (resetIndex) {
            this.data.startIndex = 0;
        }
        this.isExterior = true;
        this.activeGallery = this.exteriorGallery;
        this.cdr.markForCheck();
    }

    selectInteriorGallery(resetIndex: boolean) {
        if (resetIndex) {
            this.data.startIndex = 0;
        }
        this.isExterior = false;
        this.activeGallery = this.interiorGallery;
        this.cdr.markForCheck();
    }

    onSliderClose() {
        this.overlayRef.close();
    }
}
